var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHigher = function SvgHigher(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 11,
    height: 11,
    rx: 2.5,
    stroke: "#d93b42"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.92 9V3.784h1.177v2.008h1.8V3.784H8.08V9H6.897V6.824h-1.8V9H3.92Z",
    fill: "#d93b42"
  })));
};
export { SvgHigher as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='100%25' height='100%25' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect x='0.5' y='0.5' width='11' height='11' rx='2.5' stroke='%23d93b42'/%3E %3Cpath d='M3.92069 9V3.784H5.09669V5.792H6.89669V3.784H8.08069V9H6.89669V6.824H5.09669V9H3.92069Z' fill='%23d93b42'/%3E %3C/svg%3E";